import React from "react";
import "./barMenuStyle.css";
import MenuButtons from "./MenuButtons";
import useBarMenuManager from "./hooks/useBarMenuManager";
import { ChevronBackOutline, ChevronForwardOutline } from "react-ionicons";
import { AssortGroup } from "../../../models/AssortGroup";

const colorIcon = "var(--primary-color)";

interface IProps {
  activeGroup: AssortGroup;
  setActiveGroup: (value: AssortGroup) => void;
}

const BarMenu: React.FC<IProps> = ({ activeGroup, setActiveGroup }: IProps) => {
  const { menuList, currentPage, setCurrentPage, maxPage } = useBarMenuManager(setActiveGroup);

  return (
    <div className={"bar-menu-wrapper"}>
      <button
        disabled={currentPage === 0}
        className={"btn-change-page prev"}
        onClick={() => setCurrentPage(currentPage - 1)}
      >
        <ChevronBackOutline color={colorIcon} title={"prev"} height="30px" width="30px" />
      </button>
      <MenuButtons
        assortGroup={menuList}
        currentPage={currentPage}
        onSelect={(value: AssortGroup) => {
          setActiveGroup(value);
        }}
        activeGroup={activeGroup}
      />
      <button
        disabled={currentPage === maxPage}
        className={"btn-change-page next"}
        onClick={() => setCurrentPage(currentPage + 1)}
      >
        <ChevronForwardOutline color={colorIcon} title={"next"} height="30px" width="30px" />
      </button>
    </div>
  );
};

export default BarMenu;
